/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExternalDocumentTypeDto } from '../../models/external-document-type-dto';

export interface GetAllDocumentTypes$Params {
}

export function getAllDocumentTypes(http: HttpClient, rootUrl: string, params?: GetAllDocumentTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExternalDocumentTypeDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllDocumentTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ExternalDocumentTypeDto>>;
    })
  );
}

getAllDocumentTypes.PATH = '/external-document/types/all';
